import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { FunctionComponent } from "react";
import ListItemButton from '@mui/material/ListItemButton';
import { Tooltip } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import StoreIcon from '@mui/icons-material/Store';
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SmsIcon from '@mui/icons-material/Sms';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import QuizIcon from '@mui/icons-material/Quiz';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FoundationProgramMenu } from "../common/foundationProgramMenu/foundationProgramMenu";
import { OlympiadExamMenu } from "../common/OlympiadExamMenu/olympiadExamMenu";
import { VideoLessionFilesMenu } from "../common/videoLessionFilesMenu/VideoLessionFilesMenu";
import { isSelected } from "../common/utilities/utils";

const EXPANDED_WIDTH = 280;
const COLLAPSED_WIDTH = 64;


export const FacilitatorNavMenu: FunctionComponent = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = React.useState(true);
  const expandMenu = () => setMenuOpen(true);

  return (
    <>
      <CssBaseline />
      <Drawer
        variant="permanent"
        className="menu-container"
        sx={{
          flexShrink: 0,
          width: menuOpen ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
          transition: 'width 0.25s ease',
          "& .MuiDrawer-paper": {
            width: menuOpen ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
            boxSizing: "border-box",
            paddingTop: 10,
            overflowX: 'hidden',
            transition: 'width 0.25s ease',
          },
        }}
      >
        <Box sx={{ overflow: "auto", fontSize: '0.875rem' }}>
          <List>
            {/* Collapse / expand toggle */}
            <ListItemButton
              onClick={() => setMenuOpen(!menuOpen)}
              sx={{ justifyContent: menuOpen ? 'flex-end' : 'center', minHeight: 44, px: 1.5 }}
            >
              <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                {menuOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </ListItemIcon>
            </ListItemButton>
            <Divider />

            <Tooltip title={menuOpen ? '' : 'Admin Users'} placement="right">
              <ListItemButton
                component="a"
                href="#/Facilitator/AdminUsers"
                selected={isSelected(location.pathname, "/Facilitator/AdminUsers")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <PeopleAltIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Admin Users'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <Tooltip title={menuOpen ? '' : 'Schools'} placement="right">
              <ListItemButton
                component="a"
                href="#/Schools/list"
                selected={isSelected(location.pathname, "/Schools/list")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <StoreIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Schools'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <Tooltip title={menuOpen ? '' : 'Shared Files'} placement="right">
              <ListItemButton
                component="a"
                href="#/Facilitator/sharedfiles"
                selected={isSelected(location.pathname, "/Facilitator/sharedfiles")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <FolderSharedIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Shared Files'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <FoundationProgramMenu menuCollapsed={!menuOpen} onExpandRequest={expandMenu} />
            <OlympiadExamMenu menuCollapsed={!menuOpen} onExpandRequest={expandMenu} />
            <VideoLessionFilesMenu menuCollapsed={!menuOpen} onExpandRequest={expandMenu} />

            <Tooltip title={menuOpen ? '' : 'Abhyasa Bharathi Magazine'} placement="right">
              <ListItemButton
                component="a"
                href="#/magzine/abhyasabharathi"
                selected={isSelected(location.pathname, "/magzine/abhyasabharathi")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <LibraryBooksIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Abhyasa Bharathi Magazine'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            <Tooltip title={menuOpen ? '' : 'Send SMS'} placement="right">
              <ListItemButton
                component="a"
                href="#/Facilator/SendSMS"
                selected={isSelected(location.pathname, "/Facilator/SendSMS")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <SmsIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Send SMS'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip>

            {/* <Tooltip title={menuOpen ? '' : 'Help Desk'} placement="right">
              <ListItemButton
                component="a"
                href="#/Facilitator/HelpDesk"
                selected={isSelected(location.pathname, "/Facilitator/HelpDesk")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <HelpOutlineIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Help Desk'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip> */}

            {/* <Tooltip title={menuOpen ? '' : 'FAQs'} placement="right">
              <ListItemButton
                component="a"
                href="#/Facilitator/Faqs"
                selected={isSelected(location.pathname, "/Facilitator/Faqs")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <QuizIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'FAQs'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip> */}

            {/* <Tooltip title={menuOpen ? '' : 'Exam Papers'} placement="right">
              <ListItemButton
                component="a"
                href="#/Facilitator/ExamPapers"
                selected={isSelected(location.pathname, "/Facilitator/ExamPapers") || isSelected(location.pathname, "/Facilitator/ExamPaper")}
                sx={{ justifyContent: menuOpen ? 'initial' : 'center' }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: menuOpen ? 2 : 'auto', justifyContent: 'center' }}>
                  <AssignmentIcon />
                </ListItemIcon>
                {menuOpen && <ListItemText primary={'Exam Papers'} sx={{ fontSize: '0.875rem' }} disableTypography />}
              </ListItemButton>
            </Tooltip> */}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
